//@flow

import { useQuery, type QueryResult } from 'react-query';
import useClientId from 'common/hooks/useClientId';
import usePersonnel from 'common/hooks/usePersonnel';
import { chatLogin } from 'common/modules/chat/middleware/api';

type ChatLoginResponse = {
    appId: string,
    name: string,
    userId: string,
    userToken: string
};

const useChatLogin = (): QueryResult<ChatLoginResponse> => {
    const clientId = useClientId();
    const { personnelId } = usePersonnel();

    return useQuery({
        queryKey: ['chat-login'],
        queryFn: async () => {
            const params = { clientId, personnelId };
            const resp = chatLogin.fetch(params);

            return resp;
        },
        refetchOnWindowFocus: false
    });
};

export default useChatLogin;
